/** Product glyphs match the supplied reference: Lucide TestTubes, Boxes, Waypoints.
 * Lucide ISC license and attribution: public/brand/lucide-license.txt. */
export const KEAK_PRODUCT_GLYPHS = {
  "optimize": [
    [
      "path",
      {
        "d": "M9 2v17.5A2.5 2.5 0 0 1 6.5 22A2.5 2.5 0 0 1 4 19.5V2"
      }
    ],
    [
      "path",
      {
        "d": "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5V2"
      }
    ],
    [
      "path",
      {
        "d": "M3 2h7"
      }
    ],
    [
      "path",
      {
        "d": "M14 2h7"
      }
    ],
    [
      "path",
      {
        "d": "M9 16H4"
      }
    ],
    [
      "path",
      {
        "d": "M20 16h-5"
      }
    ]
  ],
  "inference": [
    [
      "path",
      {
        "d": "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z"
      }
    ],
    [
      "path",
      {
        "d": "m7 16.5-4.74-2.85"
      }
    ],
    [
      "path",
      {
        "d": "m7 16.5 5-3"
      }
    ],
    [
      "path",
      {
        "d": "M7 16.5v5.17"
      }
    ],
    [
      "path",
      {
        "d": "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z"
      }
    ],
    [
      "path",
      {
        "d": "m17 16.5-5-3"
      }
    ],
    [
      "path",
      {
        "d": "m17 16.5 4.74-2.85"
      }
    ],
    [
      "path",
      {
        "d": "M17 16.5v5.17"
      }
    ],
    [
      "path",
      {
        "d": "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z"
      }
    ],
    [
      "path",
      {
        "d": "M12 8 7.26 5.15"
      }
    ],
    [
      "path",
      {
        "d": "m12 8 4.74-2.85"
      }
    ],
    [
      "path",
      {
        "d": "M12 13.5V8"
      }
    ]
  ],
  "omniroute": [
    [
      "path",
      {
        "d": "m10.586 5.414-5.172 5.172"
      }
    ],
    [
      "path",
      {
        "d": "m18.586 13.414-5.172 5.172"
      }
    ],
    [
      "path",
      {
        "d": "M6 12h12"
      }
    ],
    [
      "circle",
      {
        "cx": "12",
        "cy": "20",
        "r": "2"
      }
    ],
    [
      "circle",
      {
        "cx": "12",
        "cy": "4",
        "r": "2"
      }
    ],
    [
      "circle",
      {
        "cx": "20",
        "cy": "12",
        "r": "2"
      }
    ],
    [
      "circle",
      {
        "cx": "4",
        "cy": "12",
        "r": "2"
      }
    ]
  ]
} as const;
